import React, { useState, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
// import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
// import Header from '../../components/common/Header';
import Button from '../ui/Button';
import EditText from '../ui/EditText';
import UserContext from "../../context/UserContext";
import {
    activateStudent,
    getCoins,
    getMe,
    initVoice,
    lessonResult, pingLesson,
    startLesson,
    initLibrary,
    initLibraryWithGrade,
    submitLesson,
    submitLessonPractice,
    uploadToS3,
    watchLessonSubmission
} from '../../resources/api'
import SearchView from '../ui/SearchView';

const Shelf = () => {
    const [selectedMyStories, setSelectedMyStories] = useState(true);
    const [levelUpValue, setLevelUpValue] = useState('');
    const [levelDownValue, setLevelDownValue] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);


    const navigate = useNavigate();
    const [currentCarousel1, setCurrentCarousel1] = useState(0);
    const [currentCarousel2, setCurrentCarousel2] = useState(0);

    const [books1, setBooks1] = useState([]);
    const [books2, setBooks2] = useState([]);

    const [emeralds, setEmeralds] = useState(0);
    const [sapphires, setSapphires] = useState(0);
    const [rubies, setRubies] = useState(0);

    const [progress, setProgress] = useState([]);


    const [selectedGrade, setSelectedGrade] = useState(null);

    const [showLevelDownDropdown, setShowLevelDownDropdown] = useState(false);
    const levelDownDropdownRef = useRef(null);


    const { user } = useContext(UserContext);

    const userGrade = user?.grade ?? 1;
    const activeGrade = user?.activeGrade ?? userGrade;

    const shouldBlurBook = useCallback((bookId) => {
        if (!progress || progress.length === 0) return false;

        const bookProgress = progress.find(p => p.book?.id === bookId);

        if (!bookProgress || !bookProgress.quizAttempts || bookProgress.quizAttempts.length === 0) return false;

        const latestAttempt = bookProgress.quizAttempts[0]; // Assuming attempts are ordered by created_at desc

        if (latestAttempt.isComplete && latestAttempt.passed) {
            console.log(`Book ${bookId} should be blurred: completed and passed`);
            return true;
        }

        if (latestAttempt.isComplete && !latestAttempt.passed) {
            const shouldBlur = latestAttempt.attemptNumber >= 3;
            return shouldBlur;
        }
        return false;
    }, [progress]);

    const getGemWithCount = useCallback((bookId) => {
        if (!progress || progress.length === 0) return null;

        const bookProgress = progress.find(p => p.book?.id === bookId);
        if (!bookProgress || !bookProgress.gems) return null;
        const { emerald, sapphire, ruby } = bookProgress.gems;

        if (emerald > 0) {
            return { type: 'emerald', count: emerald, icon: '/images/img_vector.svg', alt: 'emerald' };
        }
        if (sapphire > 0) {
            return { type: 'sapphire', count: sapphire, icon: '/images/img_vector_light_blue_300.svg', alt: 'sapphire' };
        }
        if (ruby > 0) {
            return { type: 'ruby', count: ruby, icon: '/images/img_vector_red_a200.svg', alt: 'ruby' };
        }
        return null;
    }, [progress]);

    const allGrades = [
        { id: 1, name: "Grade 1" },
        { id: 2, name: "Grade 2" },
        { id: 3, name: "Grade 3" },
        { id: 4, name: "Grade 4" },
        { id: 5, name: "Grade 5" },
        { id: 6, name: "Grade 6" },
        { id: 7, name: "Grade 7" },
        { id: 8, name: "Grade 8" },
    ];

    // const grades = allGrades.filter(g => g.id < userGrade);
    const currentGrade = selectedGrade ?? userGrade;
    // Grades above user's grade (locked)
    // const grades2 = allGrades
    //     .filter(g => g.id > userGrade);
    const grades = allGrades.filter(g => g.id < currentGrade && g.id <= activeGrade);
    // .map(g => ({ ...g, locked: true }));


    const grades2 = selectedGrade && selectedGrade < userGrade
        ? allGrades
            .filter(g => g.id > selectedGrade && g.id <= userGrade)
            .map(g => ({ ...g, locked: g.id > activeGrade }))
        : allGrades
            .filter(g => g.id > userGrade)
            .map(g => ({ ...g, locked: g.id > activeGrade }));
    // const grades = [
    //     { id: 1, name: "Grade 1" },
    //     { id: 2, name: "Grade 2" }
    // ];
    // const grades2 = [
    //     { id: 2, name: "Grade 2" }, // selected
    //     { id: 3, name: "Grade 3", locked: true },
    //     { id: 4, name: "Grade 4", locked: true },
    //     { id: 5, name: "Grade 5", locked: true },
    //     { id: 6, name: "Grade 6", locked: true },
    //     { id: 7, name: "Grade 7", locked: true },
    //     { id: 8, name: "Grade 8", locked: true },
    // ];

    // const books1 = [
    //     { id: 1, src: '/images/img_childrens_book_cover.png', title: 'My Happy Day' },
    //     { id: 2, src: '/images/img_childrens_book_cover_296x218.png', title: 'Doing Your Best' },
    //     { id: 3, src: '/images/img_shelf_book.png', title: 'The Purple Frog' },
    //     { id: 4, src: '/images/img_childrens_book_cover_1.png', title: 'Our Home' },
    //     { id: 5, src: '/images/img_childrens_book_cover_2.png', title: 'About the Sky' },
    //     { id: 6, src: '/images/img_childrens_book_cover_3.png', title: 'The Rabbit' },
    //     { id: 7, src: '/images/img_childrens_book_cover_4.png', title: 'Book 7' },
    //     { id: 8, src: '/images/img_childrens_book_cover_5.png', title: 'Book 8' }
    // ];

    // const books2 = [
    //     { id: 1, src: '/images/img_childrens_book_cover_296x218.png', title: 'About the Sky' },
    //     { id: 2, src: '/images/img_childrens_book_cover_3.png', title: 'My Happy Book' },
    //     { id: 3, src: '/images/img_childrens_book_cover.png', title: 'Our Home' },
    //     { id: 4, src: '/images/img_childrens_book_cover_2.png', title: 'The Rabbit' },
    //     { id: 5, src: '/images/img_childrens_book_cover_4.png', title: 'My Very Best Friend' },
    //     { id: 6, src: '/images/img_childrens_book_cover_5.png', title: 'The Purple Frog' },
    //     { id: 7, src: '/images/img_childrens_book_cover_1.png', title: 'Book 7' },
    //     { id: 8, src: '/images/img_shelf_book.png', title: 'Book 8' }
    // ];


    const bookWidth = window.innerWidth < 640 ? 160 : 218; // sm breakpoint
    const gap = 18;

    const nextCarousel1 = () => {
        // setCurrentCarousel1((prev) => (prev + 1) % Math.ceil(books1.length / 4));
        setCurrentCarousel1((prev) => Math.min(prev + 1, books1.length - 1));
    };

    const prevCarousel1 = () => {
        // setCurrentCarousel1((prev) => (prev - 1 + Math.ceil(books1.length / 4)) % Math.ceil(books1.length / 4));
        setCurrentCarousel1((prev) => Math.max(prev - 1, 0));
    };

    const nextCarousel2 = () => {

        // setCurrentCarousel2((prev) => (prev + 1) % Math.ceil(books2.length / 4));
        setCurrentCarousel2((prev) => Math.min(prev + 1, books2.length - 1));
    };

    const prevCarousel2 = () => {
        // setCurrentCarousel2((prev) => (prev - 1 + Math.ceil(books2.length / 4)) % Math.ceil(books2.length / 4));
        setCurrentCarousel2((prev) => Math.max(prev - 1, 0));
    };

    // const submitResult = useCallback((data, dontPlayStatus = false, callback) => {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const { id } = loadedData;
    //             countDownDetails?.stop?.()
    //             setCurrentStatus("processing")
    //             const res = await submitActivity(id, {
    //                 ...data
    //             }, () => { }, {
    //                 soundManager,
    //                 dontPlayStatus
    //             });

    //             if (callback) {
    //                 await callback(res)
    //             }

    //             setCurrentStatus(res.isCorrect ? "correct" : "incorrect")
    //             resolve(res)
    //             await wait(1000)

    //             setCurrentStatus(null)



    //             setIsQuestioning(false)

    //             if (res.isEnd) {
    //                 onEnd()
    //             } else {
    //                 if (res.retry) {
    //                     setRepeatCount(res.triedAmount)
    //                     setIsQuestioning(true)
    //                 } else {
    //                     setRepeatCount(0)
    //                     setTimeout(() => {
    //                         setQuestionIndex(res.nextIndex)
    //                         setIsQuestioning(true)
    //                     }, 1000)
    //                 }

    //             }



    //         } catch (e) {
    //             reject(e)
    //         }

    //     });



    // }, [loadedData]);


    const fetchBooks = useCallback(() => {

        //  const fetchBooks = async () => {
        //     try {
        //         const [books1Res, books2Res] = await Promise.all([
        //             getBooks1(), 
        //             getBooks2(), 
        //         ]);
        //         setBooks1(books1Res.data); 
        //         setBooks2(books2Res.data);
        //     } catch (error) {
        //         console.error("Error fetching books:", error);
        //     }
        // };
        // fetchBooks();
        window.soundManager.cleanAllChannel()
        // setLoadedInfo({})
        // setPageDetails({ page: "loading", stage: null })
        initLibrary().then(res => {
            console.log(res);
            console.log(res.data.books.books);
            const allBooks = res.data.books.books || [];
            const mid = Math.ceil(allBooks.length / 2);
            setBooks1(allBooks.slice(0, mid));
            setBooks2(allBooks.slice(mid));
            // setBooks1(res.data.books.books);
            // setBooks2(res.data.books.books);

            // Store progress data for quiz attempt checking
            setProgress(res.data.progress || []);

            // Gemstones (adjust property names if needed)
            setEmeralds(res.data.gems?.emerald ?? 0);
            setSapphires(res.data.gems?.sapphire ?? 0);
            setRubies(res.data.gems?.ruby ?? 0);
            // if (!res.data.otherRequirements) {
            //     getCoins(res.data.trialId).then(coins => {
            //         setCoinBucketsData(coins)
            //         setLoadedInfo({ ...res.data });

            //         if ((res.data.notFirstPlay) || (res.data.isExtra) || (lessonDetails.noIntroduction)) {
            //             (async () => {
            //                 await _setCurrent(res.data.current)
            //                 setPageDetails({ page: "lesson", stage: lessonDetails.data[res.data.current].group })

            //             })()

            //         } else {
            //             console.log(lessonDetails);
            //             console.log(res.data.current);
            //             console.log(lessonDetails.data);
            //             console.log(lessonDetails.data[res.data.current]);
            //             // console.log(lessonDetails.data[res.data.current].group);
            //             setPageDetails({ page: "introduction", stage: lessonDetails.data[res.data.current].group })
            //         }

            //     })
            // } else {
            //     setPage("requirements")
            //     setLessonRequirements(res.data.otherRequirements)
            //     //window.switchToErrorPage("")
            //     //setPlayDetails({...res.data,})
            // }


        })
    }, []);
    useEffect(() => {
        fetchBooks();
    }, [fetchBooks])

    const [dailySetReached, setDailySetReached] = useState(false);
    const [showDailyModal, setShowDailyModal] = useState(false);
    useEffect(() => {
        getMe()
            .then((res) => setDailySetReached(res?.data?.latestQuizTaken === true))
            .catch(() => { });
    }, []);
    const openBook = (book) => {
        if (dailySetReached) {
            setShowDailyModal(true);
            return;
        }
        const dest = `/bookContent/${book.id}`;
        navigate(dest, { state: { book: book, grade: selectedGrade ?? userGrade } });
    };


    // const startActivity = useCallback(() => {
    //     initCT().then((data) => {
    //         if (data.programIsDone) {
    //             setIsProgramDone(true)
    //             return;
    //         }

    //         if (!user.ctVideoPresented) {
    //             setPresentIntroduction(true);
    //         } else if (!user.guidedPracticePresented) {
    //             setPresentGuidedPractice(true);
    //         }

    //         setTitleShowing(true)


    //         //x   setLoadedData(data)

    //         const { id, itemNumber, qIndex } = data;

    //         const dayIndex = (itemNumber - 1) % 4;
    //         const lessonId = Math.ceil((itemNumber) / 4);
    //         var dayType = null;
    //         if (dayIndex == 0) {
    //             dayType = "day1";
    //         } else if (dayIndex == 1) {
    //             dayType = "day2";
    //         } else if (dayIndex == 2) {
    //             dayType = "day3";
    //         } else {
    //             dayType = "day4";
    //         }
    //         setQuestionIndex(qIndex)
    //         setLoadedData({
    //             dayType,
    //             id,
    //             itemNumber,
    //             qIndex,
    //             lessonId
    //         })
    //     });
    // }, [user]);

    // useEffect(() => {
    //     var pingInterval = null;
    //     if (loadedData?.id) {
    //         pingInterval = setInterval(() => {
    //             pingCriticalThinking(loadedData.id)
    //         }, 5000)
    //     }
    //     return () => {
    //         clearInterval(pingInterval)
    //     }
    // }, [loadedData?.id])
    // useEffect(() => {
    //     startActivity()
    // }, []);

    // const onEnd = useCallback(() => {
    //     setLoadedData(null)
    //     resultCT().then((data) => {
    //         console.log
    //         //console.log(data);
    //         setLoadedData({
    //             dayType: "end",
    //             ...data
    //         })
    //     });
    // }, []);

    // useEffect(() => {
    //     (async () => {
    //         if (countDownDetails?.state === "complete") {
    //             await wait(500)
    //             if (countDownDetails?.timerMeta) {
    //                 await countDownDetails?.timerMeta()
    //             } else {
    //                 // if (submitButton?.onClick) {
    //                 //     await submitButton?.onClick()
    //                 // }
    //                 setIsTimeOutOpen(true)
    //                 await playSound("click")
    //                 try {
    //                     const retrivePausage = await delayAll();
    //                     retrivePausedFunction = async () => {
    //                         await retrivePausage()
    //                         await submitButton?.onClick()

    //                     };
    //                 } catch (e) {
    //                     console.error(e)
    //                 }
    //             }


    //         }
    //     })().catch(alert)

    // }, [countDownDetails?.state, submitResult])

    // Hide dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // Dropdown state and ref
    const [showGradeDropdown, setShowGradeDropdown] = useState(false);
    //   const [selectedGrade, setSelectedGrade] = useState(null);
    const gradeDropdownRef = useRef(null);

    // Hide dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                gradeDropdownRef.current &&
                !gradeDropdownRef.current.contains(event.target)
            ) {
                setShowGradeDropdown(false);

            }
            if (
                levelDownDropdownRef.current && !levelDownDropdownRef.current.contains(event.target)
            ) {

                setShowLevelDownDropdown(false);
            }
        }
        if (showLevelDownDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        if (showGradeDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showGradeDropdown, showLevelDownDropdown]);



    const filteredBooks1 = books1.filter(book =>
        book.title.toLowerCase().includes(searchValue.toLowerCase())
    );

    const filteredBooks2 = books2.filter(book =>
        book.title.toLowerCase().includes(searchValue.toLowerCase())
    );

    return (
        <div className="flex flex-col justify-start items-center w-full h-full min-h-screen outflow-auto"
            style={{
                backgroundImage: 'url("/images/shelf.png")',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
            {showDailyModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
                    onClick={() => setShowDailyModal(false)}>
                    <div className="bg-white rounded-2xl px-10 py-8 max-w-md text-center" onClick={(e) => e.stopPropagation()}>
                        <img src="/images/alarm_clock.jpg" alt="" className="w-28 h-28 mx-auto mb-4"
                            onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        <h2 className="text-3xl font-bold text-gray-800 mb-6">SEE YOU LATER FOR YOUR NEXT BOOK.</h2>
                        <button className="bg-[#3D74B6] text-white text-xl font-bold px-8 py-3 rounded-2xl"
                            onClick={() => setShowDailyModal(false)}>
                            OK
                        </button>
                    </div>
                </div>
            )}
            {/* <img src="/images/shelf_background.png" alt="background" /> */}
            {/* <Header /> */}
            {/* Main Content */}
            <div className="flex flex-col justify-start items-center w-full mt-[-4px]">
                {/* Navigation Section */}
                <div className="flex flex-row justify-center items-center w-full bg-global-1 px-4 sm:px-6 lg:px-[36px] py-[36px] shadow-[0px_10px_10px_#0000000c]">
                    <div className="flex flex-col sm:flex-row justify-center items-center w-full max-w-[1628px] mx-auto gap-4 sm:gap-0">
                        <div className="flex flex-col sm:flex-row justify-start items-center flex-1 gap-4 sm:gap-[40px]">
                            {/* My Stories Button */}

                            <div className="relative" ref={dropdownRef}>
                                <button
                                    className="flex flex-row gap-5 border-2 border-[#FBF5DE] justify-center items-center w-full sm:w-auto  bg-global-5 rounded-full px-6 py-[16px] hover:bg-[#e4e4e4] transition-colors"
                                    onClick={() => setShowDropdown((prev) => !prev)}
                                >
                                    <p className="text-[18px] sm:text-[24px] font-roboto font-medium leading-[22px] sm:leading-[29px] text-left text-global-1 self-end w-auto">
                                        My Stories
                                    </p>
                                    <img src="/images/img_fi_rr_angle_small_down.svg" className="w-[24px] h-[24px] sm:w-[30px] sm:h-[30px]" alt="dropdown" />
                                </button>
                                {showDropdown && (
                                    <div className="absolute left-0 mt-2 w-[550px] bg-[#f7f7f7] rounded-[20px] shadow-lg z-50 border border-gray-200">
                                        {books1.map((book) => {
                                            const isBlurred = shouldBlurBook(book.id);
                                            return (
                                                <div
                                                    key={book.id}
                                                    className={`flex items-center justify-between px-6 py-4 ${isBlurred ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} rounded-[16px] transition-colors
                                                    ${!isBlurred ? 'hover:bg-[#e0e7ff]' : ''}`}
                                                    onClick={() => {
                                                        if (!isBlurred) {
                                                            setShowDropdown(false);
                                                            openBook(book);
                                                        }
                                                    }}
                                                >
                                                    <div className="flex items-center gap-3">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_735_1886)">
                                                                <path d="M22.2 2.16297C21.6378 1.6929 20.9791 1.35236 20.2705 1.16554C19.5619 0.978712 18.8209 0.950181 18.1 1.08197L14.278 1.77597C13.3956 1.93802 12.5933 2.392 12 3.06497C11.4052 2.39084 10.6006 1.93675 9.716 1.77597L5.9 1.08197C5.17916 0.950066 4.43813 0.978222 3.72938 1.16445C3.02062 1.35067 2.36147 1.69042 1.79857 2.15963C1.23567 2.62884 0.782786 3.21604 0.471982 3.87968C0.161178 4.54332 4.88125e-05 5.26716 0 5.99997L0 16.793C5.74559e-05 17.9638 0.410977 19.0974 1.16113 19.9963C1.91129 20.8952 2.95311 21.5024 4.105 21.712L10.391 22.855C11.455 23.0483 12.545 23.0483 13.609 22.855L19.9 21.712C21.051 21.5014 22.0916 20.8938 22.8408 19.9949C23.5899 19.0961 24.0002 17.9631 24 16.793V5.99997C24.0005 5.26742 23.8394 4.54377 23.5283 3.88057C23.2171 3.21736 22.7636 2.63091 22.2 2.16297ZM11 20.928C10.916 20.916 10.832 20.902 10.748 20.887L4.463 19.745C3.77176 19.6192 3.14659 19.2548 2.69649 18.7154C2.24638 18.1759 1.99989 17.4956 2 16.793V5.99997C2 5.20432 2.31607 4.44126 2.87868 3.87865C3.44129 3.31604 4.20435 2.99997 5 2.99997C5.18109 3.0004 5.36179 3.0168 5.54 3.04897L9.36 3.74897C9.81961 3.83308 10.2353 4.07544 10.5348 4.43402C10.8344 4.79259 10.999 5.24473 11 5.71197V20.928ZM22 16.793C22.0001 17.4956 21.7536 18.1759 21.3035 18.7154C20.8534 19.2548 20.2282 19.6192 19.537 19.745L13.252 20.887C13.168 20.902 13.084 20.916 13 20.928V5.71197C12.9999 5.24358 13.1643 4.79003 13.4643 4.43038C13.7644 4.07073 14.1812 3.82781 14.642 3.74397L18.463 3.04397C18.8957 2.96524 19.3405 2.98262 19.7657 3.09488C20.191 3.20714 20.5863 3.41153 20.9238 3.69358C21.2613 3.97562 21.5326 4.32843 21.7186 4.727C21.9046 5.12556 22.0007 5.56015 22 5.99997V16.793Z" fill="#374957" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_735_1886">
                                                                    <rect width="24" height="24" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>

                                                        <span className="text-lg font-medium text-[#374957]">{book.title}</span>
                                                        {book.title === "Doing Your Best" && (
                                                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M30 11.25C29.8381 12.1576 29.4774 13.0182 28.9438 13.77L17.965 28.545C17.6169 28.9947 17.1712 29.3593 16.6614 29.6113C16.1516 29.8633 15.5912 29.9961 15.0226 29.9996C14.4539 30.0031 13.8919 29.8772 13.3791 29.6315C12.8663 29.3858 12.4161 29.0266 12.0625 28.5813L1.03 13.5C0.56135 12.8209 0.230516 12.0565 0.05625 11.25H7.89125L13.8325 26.6988C13.9229 26.9351 14.0829 27.1385 14.2914 27.2819C14.4999 27.4254 14.7469 27.5022 15 27.5022C15.2531 27.5022 15.5001 27.4254 15.7086 27.2819C15.9171 27.1385 16.0771 26.9351 16.1675 26.6988L22.1087 11.25H30ZM22.125 8.75H29.9463C29.7561 7.90427 29.3912 7.10764 28.875 6.41125L25.6775 2.09375C25.2145 1.44657 24.6038 0.919064 23.8963 0.554949C23.1887 0.190833 22.4045 0.000595795 21.6088 2.41697e-06H18.8587L22.125 8.75ZM13.885 2.41697e-06L10.5613 8.75H19.4513L16.1938 2.41697e-06H13.885ZM7.8875 8.75L11.21 2.41697e-06H8.3075C7.51848 -0.00077429 6.74053 0.185659 6.03757 0.543986C5.3346 0.902313 4.72668 1.42231 4.26375 2.06125L1.1725 6.11375C0.581006 6.88879 0.179431 7.79169 0 8.75H7.8875ZM19.43 11.25H10.57L15 22.7675L19.43 11.25Z" fill="#27CA40" />
                                                            </svg>

                                                        )}
                                                    </div>
                                                    <div>
                                                        {/* <span className="px-4 py-2 rounded-full bg-[#2563eb] text-white text-base font-semibold">New</span>
                                                    <span className="px-4 py-2 rounded-full bg-[#22c55e] text-white text-base font-semibold">Complete</span>
                                                    <span className="px-4 py-2 rounded-full bg-[#f87171] text-white text-base font-semibold">Re-Read</span> */}
                                                        <span className="px-4 py-2 rounded-full bg-[#a3a3a3] text-white text-base font-semibold">Unread</span>
                                                        {/* {book.status === "new" && (
                                                        <span className="px-4 py-2 rounded-full bg-[#2563eb] text-white text-base font-semibold">New</span>
                                                    )}
                                                    {book.status === "complete" && (
                                                        <span className="px-4 py-2 rounded-full bg-[#22c55e] text-white text-base font-semibold">Complete</span>
                                                    )}
                                                    {book.status === "reread" && (
                                                        <span className="px-4 py-2 rounded-full bg-[#f87171] text-white text-base font-semibold">Re-Read</span>
                                                    )}
                                                    {book.status === "unread" && (
                                                        <span className="px-4 py-2 rounded-full bg-[#a3a3a3] text-white text-base font-semibold">Unread</span>
                                                    )} */}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            {/* <div className="flex flex-row gap-[10px] justify-center items-center w-full sm:w-auto rounded-[24px] px-[6px] py-[6px]">
                                <p className="text-[18px] sm:text-[24px] font-roboto font-medium leading-[22px] sm:leading-[29px] text-left text-global-1 self-end w-auto">
                                    My Stories
                                </p>
                                <img src="/images/img_fi_rr_angle_small_down.svg" className="w-[24px] h-[24px] sm:w-[30px] sm:h-[30px]" alt="dropdown" />
                            </div> */}



                            {/* <div className="flex items-center gap-5 border-2 border-[#FBF5DE] rounded-full px-8 py-3">
                                <span className="text-[#FBF5DE] text-2xl font-medium">Level Up</span>
                                <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </div> */}

                            {/* Level Down */}

                            <div className="relative" ref={levelDownDropdownRef}>
                                <button
                                    className="flex flex-row gap-5 border-2 border-[#FBF5DE] justify-center items-center rounded-full px-8 py-3 hover:border-[#000000] transition-colors"
                                    onClick={() => setShowLevelDownDropdown((prev) => !prev)}
                                >
                                    <span className="text-[#FBF5DE] text-2xl font-roboto font-medium">Level Down</span>
                                    <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                </button>
                                {showLevelDownDropdown && (
                                    <div className="absolute left-0 mt-2 w-[550px] bg-[#f7f7f7] rounded-[20px] shadow-lg z-50 border border-gray-200">
                                        {grades.map((grade) => (
                                            <div
                                                key={grade.id}
                                                className={`flex items-center justify-between px-6 py-6 cursor-pointer rounded-[16px] transition-colors
            ${selectedGrade === grade.id ? "bg-[#f7f7f7]" : "hover:bg-[#e0e7ff]"}
            border-b border-[#d1d5db] last:border-b-0`}
                                                onClick={async () => {
                                                    // Only allow select if not locked
                                                    // if (grade.locked) return;
                                                    setSelectedGrade(grade.id);
                                                    setShowLevelDownDropdown(false);


                                                    // Call API to get books for the selected grade
                                                    try {
                                                        const res = await initLibraryWithGrade(grade.id);
                                                        console.log(res)
                                                        const allBooks = res.data.books.books || [];
                                                        const mid = Math.ceil(allBooks.length / 2);
                                                        setBooks1(allBooks.slice(0, mid));
                                                        setBooks2(allBooks.slice(mid));
                                                        setEmeralds(res.data.gems?.Emeralds ?? 0);
                                                        setSapphires(res.data.gems?.Sapphires ?? 0);
                                                        setRubies(res.data.gems?.Rubies ?? 0);
                                                    } catch (error) {
                                                        console.error("Error fetching books for grade:", error);
                                                    }
                                                }}
                                            >
                                                <div className="flex items-center gap-3">
                                                    {/* User icon */}
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <g>
                                                            <rect width="24" height="24" rx="6" fill="#E4E4E4" />
                                                            <path d="M9 11C9 10.7348 9.10536 10.4804 9.29289 10.2929C9.48043 10.1054 9.73478 10 10 10H14C14.2652 10 14.5196 10.1054 14.7071 10.2929C14.8946 10.4804 15 10.7348 15 11C15 11.2652 14.8946 11.5196 14.7071 11.7071C14.5196 11.8946 14.2652 12 14 12H10C9.73478 12 9.48043 11.8946 9.29289 11.7071C9.10536 11.5196 9 11.2652 9 11ZM24 18V19C23.9984 20.3256 23.4711 21.5964 22.5338 22.5338C21.5964 23.4711 20.3256 23.9984 19 24H5C3.67441 23.9984 2.40356 23.4711 1.46622 22.5338C0.528882 21.5964 0.00158786 20.3256 0 19L0 18C0.00145452 16.8478 0.40009 15.7313 1.12872 14.8387C1.85735 13.9462 2.87141 13.3321 4 13.1V12C4.00173 10.5944 4.37375 9.21415 5.07859 7.99809C5.78344 6.78203 6.79623 5.77314 8.015 5.073C8.013 5.048 8 5.026 8 5V4C8 2.93913 8.42143 1.92172 9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V5C16 5.026 15.987 5.048 15.985 5.073C17.2038 5.77314 18.2166 6.78203 18.9214 7.99809C19.6263 9.21415 19.9983 10.5944 20 12V13.1C21.1286 13.3321 22.1427 13.9462 22.8713 14.8387C23.5999 15.7313 23.9985 16.8478 24 18ZM10 4.263C11.3103 3.91233 12.6897 3.91233 14 4.263V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V4.263ZM6 16.535C6.77985 15.7328 7.71265 15.0952 8.74322 14.6597C9.77379 14.2243 10.8812 14 12 14C13.1188 14 14.2262 14.2243 15.2568 14.6597C16.2874 15.0952 17.2201 15.7328 18 16.535V12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12V16.535ZM5 22H5.026C4.36419 21.1396 4.00368 20.0855 4 19V15.184C3.41709 15.3901 2.91209 15.7712 2.55409 16.2753C2.19608 16.7794 2.00256 17.3817 2 18V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22ZM15 22C15.6517 21.997 16.2847 21.7818 16.8032 21.387C17.3217 20.9923 17.6976 20.4394 17.874 19.812C17.3677 18.6771 16.5436 17.7132 15.5011 17.0368C14.4587 16.3604 13.2427 16.0004 12 16.0004C10.7573 16.0004 9.54129 16.3604 8.49886 17.0368C7.45644 17.7132 6.63227 18.6771 6.126 19.812C6.30239 20.4394 6.67827 20.9923 7.1968 21.387C7.71533 21.7818 8.34831 21.997 9 22H15ZM22 18C21.9974 17.3817 21.8039 16.7794 21.4459 16.2753C21.0879 15.7712 20.5829 15.3901 20 15.184V19C19.9963 20.0855 19.6358 21.1396 18.974 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V18Z" fill="#374957" />
                                                        </g>
                                                    </svg>
                                                    <span className="text-xl font-medium text-[#374957]">{grade.name}</span>
                                                </div>

                                                <div>
                                                    {selectedGrade === grade.id ? (
                                                        <span className="px-6 py-3 rounded-full bg-[#f7f3e3] border border-[#d1d5db] text-[#374957] text-lg font-semibold">Selected</span>
                                                    ) : (
                                                        <span className="px-6 py-3 rounded-full bg-[#2563eb] text-white text-lg font-semibold">Select Grade</span>
                                                    )}
                                                </div>
                                                {/* <div>
                                                    {selectedGrade === grade.id ? (
                                                        <span className="px-6 py-1 rounded-full bg-[#f7f3e3] border border-[#d1d5db] text-[#374957] text-lg font-semibold">Selected</span>
                                                    ) : (
                                                        <span className="px-6 py-1 rounded-full bg-[#a3a3a3] text-white text-lg font-semibold flex items-center gap-2">
                                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.5 4.212V3.5C9.5 2.57174 9.13125 1.6815 8.47487 1.02513C7.8185 0.368749 6.92826 0 6 0C5.07174 0 4.1815 0.368749 3.52513 1.02513C2.86875 1.6815 2.5 2.57174 2.5 3.5V4.212C2.05468 4.40635 1.67565 4.72626 1.40925 5.13261C1.14285 5.53895 1.00064 6.01412 1 6.5V9.5C1.00079 10.1628 1.26444 10.7982 1.73311 11.2669C2.20178 11.7356 2.8372 11.9992 3.5 12H8.5C9.1628 11.9992 9.79822 11.7356 10.2669 11.2669C10.7356 10.7982 10.9992 10.1628 11 9.5V6.5C10.9994 6.01412 10.8571 5.53895 10.5908 5.13261C10.3244 4.72626 9.94532 4.40635 9.5 4.212ZM3.5 3.5C3.5 2.83696 3.76339 2.20107 4.23223 1.73223C4.70107 1.26339 5.33696 1 6 1C6.66304 1 7.29893 1.26339 7.76777 1.73223C8.23661 2.20107 8.5 2.83696 8.5 3.5V4H3.5V3.5ZM10 9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11H3.5C3.10218 11 2.72064 10.842 2.43934 10.5607C2.15804 10.2794 2 9.89782 2 9.5V6.5C2 6.10218 2.15804 5.72064 2.43934 5.43934C2.72064 5.15804 3.10218 5 3.5 5H8.5C8.89782 5 9.27936 5.15804 9.56066 5.43934C9.84196 5.72064 10 6.10218 10 6.5V9.5Z" fill="#FBF5DE" />
                                                                <path d="M6 6.99988C5.86739 6.99988 5.74022 7.05256 5.64645 7.14632C5.55268 7.24009 5.5 7.36727 5.5 7.49988V8.49988C5.5 8.63248 5.55268 8.75966 5.64645 8.85343C5.74022 8.9472 5.86739 8.99987 6 8.99987C6.13261 8.99987 6.25979 8.9472 6.35356 8.85343C6.44733 8.75966 6.50001 8.63248 6.50001 8.49988V7.49988C6.50001 7.36727 6.44733 7.24009 6.35356 7.14632C6.25979 7.05256 6.13261 6.99988 6 6.99988Z" fill="#FBF5DE" />
                                                            </svg> */}

                                                {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                                <rect width="24" height="24" rx="6" fill="#a3a3a3" />
                                                                <path d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg> */}
                                                {/* Locked
                                                        </span>
                                                    )}
                                                </div> */}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>



                            {/* Level Up */}

                            <div className="relative" ref={gradeDropdownRef}>
                                <button
                                    className="flex flex-row gap-5 border-2 border-[#FBF5DE] justify-center items-center rounded-full px-8 py-3 hover:border-[#000000] transition-colors"
                                    onClick={() => setShowGradeDropdown((prev) => !prev)}
                                >
                                    <span className="text-[#FBF5DE] text-2xl font-roboto font-medium">Level Up</span>
                                    <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                    {/* <img src="/images/img_fi_rr_angle_small_down.svg" className="w-[24px] h-[24px]" alt="dropdown" /> */}
                                </button>
                                {showGradeDropdown && (
                                    <div className="absolute left-0 mt-2 w-[550px] bg-[#f7f7f7] rounded-[20px] shadow-lg z-50 border border-gray-200">
                                        {grades2.map((grade) => {
                                            const isLocked = grade.locked;
                                            return (
                                                <div
                                                    key={grade.id}
                                                    className={`flex items-center justify-between px-6 py-6 rounded-[16px] transition-colors
                      ${isLocked ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
                      ${selectedGrade === grade.id ? "bg-[#f7f7f7]" : !isLocked && "hover:bg-[#e0e7ff]"}
                      border-b border-[#d1d5db] last:border-b-0`}
                                                    onClick={async () => {
                                                        if (isLocked) return; // Don't allow clicking locked grades

                                                        setSelectedGrade(grade.id);
                                                        setShowGradeDropdown(false);

                                                        try {
                                                            const res = await initLibraryWithGrade(grade.id);
                                                            const allBooks = res.data.books.books || [];
                                                            const mid = Math.ceil(allBooks.length / 2);
                                                            setBooks1(allBooks.slice(0, mid));
                                                            setBooks2(allBooks.slice(mid));
                                                            setEmeralds(res.data.gems?.Emeralds ?? 0);
                                                            setSapphires(res.data.gems?.Sapphires ?? 0);
                                                            setRubies(res.data.gems?.Rubies ?? 0);
                                                        } catch (error) {
                                                            console.error("Error fetching books for grade:", error);
                                                        }
                                                    }}
                                                >
                                                    <div className="flex items-center gap-3">
                                                        {/* User icon */}
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_735_1714)">
                                                                <path d="M9 11C9 10.7348 9.10536 10.4804 9.29289 10.2929C9.48043 10.1054 9.73478 10 10 10H14C14.2652 10 14.5196 10.1054 14.7071 10.2929C14.8946 10.4804 15 10.7348 15 11C15 11.2652 14.8946 11.5196 14.7071 11.7071C14.5196 11.8946 14.2652 12 14 12H10C9.73478 12 9.48043 11.8946 9.29289 11.7071C9.10536 11.5196 9 11.2652 9 11ZM24 18V19C23.9984 20.3256 23.4711 21.5964 22.5338 22.5338C21.5964 23.4711 20.3256 23.9984 19 24H5C3.67441 23.9984 2.40356 23.4711 1.46622 22.5338C0.528882 21.5964 0.00158786 20.3256 0 19L0 18C0.00145452 16.8478 0.40009 15.7313 1.12872 14.8387C1.85735 13.9462 2.87141 13.3321 4 13.1V12C4.00173 10.5944 4.37375 9.21415 5.07859 7.99809C5.78344 6.78203 6.79623 5.77314 8.015 5.073C8.013 5.048 8 5.026 8 5V4C8 2.93913 8.42143 1.92172 9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V5C16 5.026 15.987 5.048 15.985 5.073C17.2038 5.77314 18.2166 6.78203 18.9214 7.99809C19.6263 9.21415 19.9983 10.5944 20 12V13.1C21.1286 13.3321 22.1427 13.9462 22.8713 14.8387C23.5999 15.7313 23.9985 16.8478 24 18ZM10 4.263C11.3103 3.91233 12.6897 3.91233 14 4.263V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V4.263ZM6 16.535C6.77985 15.7328 7.71265 15.0952 8.74322 14.6597C9.77379 14.2243 10.8812 14 12 14C13.1188 14 14.2262 14.2243 15.2568 14.6597C16.2874 15.0952 17.2201 15.7328 18 16.535V12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12V16.535ZM5 22H5.026C4.36419 21.1396 4.00368 20.0855 4 19V15.184C3.41709 15.3901 2.91209 15.7712 2.55409 16.2753C2.19608 16.7794 2.00256 17.3817 2 18V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22ZM15 22C15.6517 21.997 16.2847 21.7818 16.8032 21.387C17.3217 20.9923 17.6976 20.4394 17.874 19.812C17.3677 18.6771 16.5436 17.7132 15.5011 17.0368C14.4587 16.3604 13.2427 16.0004 12 16.0004C10.7573 16.0004 9.54129 16.3604 8.49886 17.0368C7.45644 17.7132 6.63227 18.6771 6.126 19.812C6.30239 20.4394 6.67827 20.9923 7.1968 21.387C7.71533 21.7818 8.34831 21.997 9 22H15ZM22 18C21.9974 17.3817 21.8039 16.7794 21.4459 16.2753C21.0879 15.7712 20.5829 15.3901 20 15.184V19C19.9963 20.0855 19.6358 21.1396 18.974 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V18Z" fill="#374957" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_735_1714">
                                                                    <rect width="24" height="24" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>

                                                        {/* <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                                        <rect width="24" height="24" rx="6" fill="#E4E4E4" />
                                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#374957" />
                                                    </svg> */}
                                                        <span className="text-xl font-medium text-[#374957]">{grade.name}</span>
                                                    </div>
                                                    <div>
                                                        {isLocked ? (
                                                            <span className="px-6 py-3 rounded-full bg-[#a3a3a3] text-white text-lg font-semibold flex items-center gap-2">
                                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                                    <rect width="24" height="24" rx="6" fill="#a3a3a3" />
                                                                    <path d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                                Locked
                                                            </span>
                                                        ) : selectedGrade === grade.id ? (
                                                            <span className="px-6 py-3 rounded-full bg-[#f7f3e3] border border-[#d1d5db] text-[#374957] text-lg font-semibold">Selected</span>
                                                        ) : (
                                                            <span className="px-6 py-3 rounded-full bg-[#2563eb] text-white text-lg font-semibold">Select Grade</span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            {/* <div className="flex items-center gap-5 border-2 border-[#FBF5DE] rounded-full px-8 py-3">
                                <span className="text-[#FBF5DE] text-2xl font-medium">Level Down</span>
                                <svg className="w-8 h-8 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </div> */}
                            {/* <EditText
                placeholder="Level Up"
                value={levelUpValue}
                onChange={(e) => setLevelUpValue(e?.target?.value)}
                rightImage={{
                  src: "/images/img_firranglesmalldown_orange_50.svg",
                  width: 30,
                  height: 30
                }}
                className="w-full sm:w-auto"
              /> */}

                            {/* <EditText
                placeholder="Level Down"
                value={levelDownValue}
                onChange={(e) => setLevelDownValue(e?.target?.value)}
                rightImage={{
                  src: "/images/img_firranglesmalldown_orange_50.svg",
                  width: 30,
                  height: 30
                }}
                className="w-full sm:w-auto"
              /> */}
                        </div>

                        {/* Search */}
                        <SearchView
                            placeholder="Search Your Library"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e?.target?.value)}
                            leftImage={{
                                src: "/images/img_search.svg",
                                width: 24,
                                height: 24
                            }}
                            className="w-full sm:w-[32%]"
                        />
                    </div>
                </div>

                {/* Content Area */}
                <div className="flex flex-row justify-start items-center w-full ">
                    <div className="relative w-full">
                        {/* Background Container */}
                        <div className="w-full max-w-[1628px] mx-auto px-4 sm:px-6 lg:px-0">
                            {/* Side Decorations */}
                            <div className="hidden lg:block absolute left-[50px] top-[55px] w-[52px] h-[90%] bg-[linear-gradient(180deg,#fbf5de_0%,_#b5a25b_100%)] rounded-[26px] shadow-[0px_0px_50px_#00000026]"></div>
                            <div className="hidden lg:block absolute right-[50px] top-[55px] w-[52px] h-[90%] bg-[linear-gradient(180deg,#fbf5de_0%,_#b5a25b_100%)] rounded-[26px] shadow-[0px_0px_50px_#00000026]"></div>

                            {/* Main Content */}
                            <div className="flex flex-col justify-start items-center w-full lg:max-w-[1522px] mx-auto mb-[62px]">
                                {/* Gemstones Section */}
                                <div className="flex flex-row w-full">
                                    <div className="flex flex-col justify-start items-center w-full mt-20">
                                        <div className="flex flex-col sm:flex-row justify-center items-center w-full px-4 sm:px-[84px] lg:px-[84px] pr-4 sm:pr-[56px] lg:pr-[56px]">

                                            {/* Gemstones Row */}
                                            <div className='w-[40%] justify-center'>


                                                <div className="flex flex-col justify-center items-center sm:flex-row gap-4 sm:gap-[114px] flex-1 bg-[linear-gradient(180deg,#fbf5de_0%,_#ded3ab_100%)] rounded-t-[64px] px-4 sm:px-[80px] lg:px-[80px] pr-4 sm:pr-[56px] lg:pr-[56px] py-[20px] shadow-[0px_0px_20px_#00000026] mx-auto">
                                                    {/* Emeralds */}
                                                    <div className="flex flex-col gap-[2px] justify-start items-center w-full sm:w-[130px]">
                                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-center text-global-1">
                                                            Emeralds
                                                        </p>
                                                        <div className="flex flex-row gap-[20px] justify-center items-center w-auto">
                                                            <img src="/images/img_vector.svg" className="w-[32px] h-[32px] sm:w-[40px] sm:h-[40px]" alt="emerald" />
                                                            <p className="text-[24px] sm:text-[32px] font-cheese-matcha font-normal leading-[31px] sm:leading-[41px] text-left text-global-1">
                                                                (x{emeralds})
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Sapphires */}
                                                    <div className="flex flex-col justify-start items-center w-full sm:w-[132px]">
                                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-center text-global-1">
                                                            Sapphires
                                                        </p>
                                                        <div className="flex flex-row gap-[20px] justify-center items-center w-auto">
                                                            <img src="/images/img_vector_light_blue_300.svg" className="w-[32px] h-[32px] sm:w-[40px] sm:h-[40px]" alt="sapphire" />
                                                            <p className="text-[24px] sm:text-[32px] font-cheese-matcha font-normal leading-[31px] sm:leading-[41px] text-left text-global-1">
                                                                (x{sapphires})
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Rubies */}
                                                    <div className="flex flex-col gap-[2px] justify-start items-center w-full sm:w-[126px]">
                                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-center text-global-1">
                                                            Rubies
                                                        </p>
                                                        <div className="flex flex-row gap-[20px] justify-center items-center w-auto">
                                                            <img src="/images/img_vector_red_a200.svg" className="w-[32px] h-[32px] sm:w-[40px] sm:h-[40px]" alt="ruby" />
                                                            <p className="text-[24px] sm:text-[32px] font-cheese-matcha font-normal leading-[31px] sm:leading-[41px] text-left text-global-1">
                                                                (x{rubies})
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-row justify-center items-center bg-[#F1E9CC]  w-[92%] text-center px-[10px] py-[10px] shadow-[0px_10px_30px_#0000003f]">
                                            <h2 className="text-2xl font-['Cheese_Matcha'] text-[#374957]">My Gemstones Collection</h2>
                                        </div>
                                        {/* Gemstones Collection Button */}
                                        {/* <Button className="w-full mt-4 rounded-none">
                                            My Gemstones Collection
                                            </Button> */}
                                    </div>
                                    {/* Tree Image */}
                                    <img src="/images/img_group.svg" className="hidden lg:block absolute top-16 right-[75%] w-full sm:w-[224px] h-auto sm:h-[132px] mb-4 sm:mb-0" alt="tree" />

                                    {/* Pineapple Image */}
                                    <img src="/images/img_frame.svg" className="hidden lg:block absolute top-3 right-[102px] w-[132px] h-[184px]" alt="pineapple" />
                                </div>

                                {/* Books Collection 1 */}
                                <div className="w-full mt-[40px]">
                                    <div className="flex flex-col justify-center items-center w-full">
                                        <div className="w-[89%]">
                                            <div className='relative w-full'>
                                                {/* Books Carousel */}
                                                <div className="w-full overflow-hidden">
                                                    <div className="flex flex-row gap-[18px] justify-start items-center w-auto px-4 sm:px-0"
                                                        // style={{ transform: `translateX(-${currentCarousel1 * 100}%)` }}
                                                        // style={{ transform: `translateX(-${currentCarousel1 * (218 + 18)}px)` }}
                                                        style={{ transform: `translateX(-${currentCarousel1 * (bookWidth + gap)}px)` }}
                                                    >
                                                        {filteredBooks1?.map((book) => {
                                                            const isBlurred = shouldBlurBook(book.id);
                                                            const gemWithCount = getGemWithCount(book.id);
                                                            return (
                                                                <div
                                                                    key={book?.id}
                                                                    className={`flex-shrink-0 w-56 h-72 ${isBlurred ? 'cursor-not-allowed opacity-50' : 'cursor-pointer transform hover:scale-105'} transition-transform`}
                                                                    onClick={() => {
                                                                        if (!isBlurred) {
                                                                            openBook(book);
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="relative">
                                                                        <img
                                                                            src={book?.coverImage}
                                                                            alt={book?.title}
                                                                            className="w-[160px] sm:w-[218px] h-[220px] sm:h-[296px] rounded-[18px] flex-shrink-0"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Navigation Arrows */}

                                        <div className="flex justify-between absolute top-1/15 -translate-y-1/2 w-[90%] px-[-75px]">
                                            <button
                                                onClick={prevCarousel1}
                                                className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                                            >
                                                <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                            </button>
                                            <button
                                                onClick={nextCarousel1}
                                                className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                                            >
                                                <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                </svg>
                                            </button>
                                        </div>
                                        {/* <div className="flex flex-row justify-between items-center w-full px-4 sm:px-[130px] mt-4">
                                            <div className="flex flex-col justify-start items-center w-auto bg-global-1 border-[5px] border-solid border-global-5 rounded-[36px] p-[14px]">
                                                <img src="/images/img_fi_rr_arrow_left.svg" className="w-[28px] h-[28px] sm:w-[36px] sm:h-[36px]" alt="previous" />
                                            </div>
                                            <div className="flex flex-col justify-start items-center w-auto bg-global-1 border-[5px] border-solid border-global-5 rounded-[36px] p-[14px]">
                                                <img src="/images/img_fi_rr_arrow_left.svg" className="w-[28px] h-[28px] sm:w-[36px] sm:h-[36px] rotate-180" alt="next" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>

                                {/* Books Collection Button */}
                                <div className=" flex flex-row justify-center items-center bg-[#DECD8D] text-center px-[10px] py-[10px] mt-1 shadow-lg w-[92%]">
                                    <h2 className="text-2xl sm:text-[24px] font-['Cheese_Matcha'] sm:leading-[31px] text-[#374957]">My Library</h2>
                                </div>
                                {/* <Button className="w-full mt-[40px] bg-global-2 rounded-none">
                                    My Books Collection
                                </Button> */}

                                {/* Books Collection 2 */}
                                <div className="w-full mt-[40px]">
                                    <div className="flex flex-col justify-center items-center w-full">
                                        <div className="w-[89%]"
                                        // bg-[linear-gradient(180deg,#0000007f_0%,_#0000007f_100%)]
                                        >
                                            <div className="relative w-full">
                                                {/* Books Carousel */}
                                                <div className="w-full 
                                                overflow-hidden"
                                                // overflow-x-auto"
                                                >
                                                    <div className="flex flex-row gap-[18px] justify-start items-center w-auto px-4 sm:px-0"
                                                        // style={{ transform: `translateX(-${currentCarousel2 * 100}%)` }}>
                                                        // style={{ transform: `translateX(-${currentCarousel2 * (218 + 18)}px)` }}>
                                                        style={{ transform: `translateX(-${currentCarousel2 * (bookWidth + gap)}px)` }}>
                                                        {filteredBooks2?.map((book) => {
                                                            const isBlurred = shouldBlurBook(book.id);
                                                            const gemWithCount = getGemWithCount(book.id);
                                                            return (
                                                                <div
                                                                    key={book.id}
                                                                    className={`flex-shrink-0 w-56 h-75 ${isBlurred ? 'cursor-not-allowed opacity-50' : 'cursor-pointer transform hover:scale-105'} transition-transform`}
                                                                    onClick={() => {
                                                                        if (!isBlurred) {
                                                                            openBook(book);
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="relative">
                                                                        <img
                                                                            src={book.coverImage}
                                                                            alt={book.title}
                                                                            className="w-[160px] sm:w-[218px] h-[220px] sm:h-[296px] rounded-[18px] flex-shrink-0"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                                {/* Navigation Arrows */}
                                                <div className="flex justify-between absolute top-1/2 -translate-y-1/2 w-full px-[-75px]">
                                                    <button
                                                        onClick={prevCarousel2}
                                                        className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                                                    >
                                                        <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={nextCarousel2}
                                                        className="w-20 h-20 bg-[#3D74B6] border-4 border-[#FBF5DE] rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                                                    >
                                                        <svg className="w-10 h-10 text-[#FBF5DE]" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                {/* <div className="flex flex-row justify-between items-center w-full px-4 sm:px-[130px] mt-4 pb-4">
                                                    <div className="flex flex-col justify-start items-center w-auto bg-global-1 border-[5px] border-solid border-global-5 rounded-[36px] p-[14px]">
                                                        <img src="/images/img_fi_rr_arrow_left.svg" className="w-[28px] h-[28px] sm:w-[36px] sm:h-[36px]" alt="previous" />
                                                    </div>
                                                    <div className="flex flex-col justify-start items-center w-auto bg-global-1 border-[5px] border-solid border-global-5 rounded-[36px] p-[14px]">
                                                        <img src="/images/img_fi_rr_arrow_left.svg" className="w-[28px] h-[28px] sm:w-[36px] sm:h-[36px] rotate-180" alt="next" />
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Level Up Section */}
                                <div className="flex flex-row justify-center items-center w-[92%] bg-global-2 px-[10px] py-[10px] shadow-[0px_10px_30px_#0000003f] mt-1 mb-5">
                                    <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-left text-global-2 mr-4">
                                        LEVEL UP!
                                    </p>
                                    <div className="flex flex-row justify-center items-center w-auto">
                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-left text-global-1">
                                            Collect
                                        </p>
                                        <img src="/images/img_vector_light_blue_300.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] ml-[10px]" alt="sapphire" />
                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-left text-global-2 ml-[10px]">
                                            (x20)
                                        </p>
                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-left text-global-1 ml-[10px]">
                                            or
                                        </p>
                                        <img src="/images/img_vector.svg" className="w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] ml-[10px]" alt="emerald" />
                                        <p className="text-[20px] sm:text-[24px] font-cheese-matcha font-normal leading-[26px] sm:leading-[31px] text-left text-global-2 ml-[10px]">
                                            (x40)
                                        </p>
                                    </div>
                                </div>

                                {/* Footer */}
                                {/* <div className="flex flex-row justify-center items-center w-full bg-[linear-gradient(180deg,#00000000_0%,#00000033_50%,#00000000_100%)] px-[20px] py-[20px] mt-[40px]">
                                    <p className="text-[16px] sm:text-[20px] font-roboto font-normal leading-[20px] sm:leading-[24px] text-left text-global-4 self-end w-auto">
                                        Read 21 © 2025 • All Rights Reserved
                                    </p>
                                </div> */}
                            </div>
                        </div>

                        {/* Bottom Decorative Images */}
                        <img src="/images/img_group_pink_900.svg" className="hidden lg:block absolute bottom-[20px] right-[50px] w-[158px] h-[218px]" alt="decoration right" />
                        <img src="/images/img_capa_1.svg" className="hidden lg:block absolute bottom-[20px] left-[40px] w-[158px] h-[218px]" alt="decoration left" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Shelf;